import { Log, apiRequest } from '@ext/utils';
import { Paginacion } from '@ext/env';
export * from './Viajante.types';
import {  IViajante, IEstadisticaArticulos, IEstadisticaVentas } from './Viajante.lib';
import moment from 'moment';

export class Viajante extends IViajante
{

    public static async create( id: number ): Promise<Viajante>
    {
        let o = new Viajante();
        o.Id = id;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }
    protected Route: string = '/viajantes';
    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Id}`;
        if ( await request.get() )
        {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Viajante>; Error?: boolean; }>
    {

        let a: Array<Viajante> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/viajantes` );
        request.params = params;
        if ( await request.get() )
        {
            if ( request.data.response )
            {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results )
            {
                for ( let i of request.data.results )
                {
                    let p = new Viajante( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

    public async save(): Promise<boolean>
    {

        try
        {
            let js = this.getJson();
            let req = new apiRequest();
            req.body = js;
            if ( this.Existe )
            {
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.put() )
                {
                    this.Json = req.data;
                    this.set();
                }
            }
            else
            {
                req.path = `${this.Route}`;
                if ( await req.post() )
                {
                    this.Json = req.data;
                    this.set();
                }
            }
            return true;
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async del(): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.delete() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }
}



export class EstadisticaVentas extends IEstadisticaVentas
{

    public static async create( id: Viajante, mes: number, ano: number ): Promise<EstadisticaVentas>
    {
        let o = new EstadisticaVentas();
        o.Viajante = id;
        o.Mes = mes;
        o.Ano = ano;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }

    public static async actual( viajante: Viajante ): Promise<EstadisticaVentas>
    {
        let o = new EstadisticaVentas();
        if ( moment().getDay() < 7 )
        {
            o.Mes = moment().add( -1, 'month' ).getMonth();
            o.Ano = moment().add( -1, 'month' ).getYear();
        }
        else
        {
            o.Mes = moment().getMonth();
            o.Ano = moment().getYear();
        }

        o.Viajante = viajante;

        if ( await o.find() )
        {
            return o;
        }
        return null;
    }

    protected Route: string = '/estadisticas/ventas/viajante';
    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.params.viajante = this.Viajante.Id;
        request.params.mes = this.Mes;
        request.params.ano = this.Ano;
        request.path = `${this.Route}`;
        if ( await request.get() )
        {
            this.Json = request.data.ventas[0];
            this.set();
        }
        return this.Existe;
    }


    public static async find( params: any ): Promise<EstadisticaVentas[]>
    {

        let request = new apiRequest();

        if ( params )
            request.params = params;

        request.path = `/estadisticas/ventas/viajante`;
        if ( await request.get() )
        {
            return request.data.ventas.map( ( x: any ) => new EstadisticaVentas( x ) );

        }
        return [];
    }

    public static async actuales( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<EstadisticaVentas>; Error?: boolean; }>
    {

        let a: Array<EstadisticaVentas> = [];
        let paginacion: Paginacion = new Paginacion();


        let request = new apiRequest();
        request.path = `/estadisticas/ventas/viajantes`;
        if ( params )
            request.params = params;
        if ( moment().getDay() < 7 )
        {
            request.params.mes = moment().add( -1, 'month' ).getMonth();
            request.params.ano = moment().add( -1, 'month' ).getYear();
        }
        else
        {
            request.params.mes = moment().getMonth();
            request.params.ano = moment().getYear();
        }

        if ( await request.get() )
        {
            if ( request.data.response )
            {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results )
            {
                for ( let i of request.data.results )
                {
                    let p = new EstadisticaVentas( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }



}
   